import TrackService from "src/services/TrackService";
import ModuleCreator from "src/store/ModuleCreator";

export const types = {
	FETCH_TRACKS: "tracks/fetch"
};
export const params = {};

/**
 @namespace
 @property  {object} module,
 @property  {object} module.state,
 @property  {object} modules.project,
 @property  {array}  modules.projects
 **/

const module = {
	state: {},
	getters: {},
	mutations: {
		[types.FETCH_TRACKS](state, tracks) {
			// Checking if user subscribed to any plan of current project
			tracks.forEach(track => {
				track.isPayed = !!track.subscriptions.length;
			});
			state.tracks = tracks;
		}
	},
	actions: {
		[types.FETCH_TRACKS](context, payload) {
			return TrackService.fetchTracks(payload).then(response => {
				context.commit(types.FETCH_TRACKS, response);
			});
		}
	},
	types: types
};
export default ModuleCreator("track", TrackService, module, types, params);
